import WSConnectionManager from './WSConnectionManager'

export const wsConnection: WSConnectionManager = new WSConnectionManager()
